const input = document.getElementById("faq-search");
function faqSearch() {
  // Declare variables
  var filter, ul, li, a, i, txtValue;
  filter = input.value.toUpperCase();
  faq = document.querySelectorAll(".collapsible-content__wrapper");

  faq.forEach((item) => {
    var li = item.querySelectorAll(".accordion");
    var txtValue = item.textContent || item.innerText;

    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      item.style.display = "";
    } else {
      item.style.display = "none";
    }

    // Loop through all list items, and hide those who don't match the search query
    for (i = 0; i < li.length; i++) {
      // a = li[i].querySelectorAll(".faq__title")[0];
      txtValue = li[i].textContent || li[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].style.display = "";
      } else {
        li[i].style.display = "none";
      }
    }
  });
}

input.addEventListener("keyup", function () {
  faqSearch();
});